import type { SocketEventHandler, SocketEventMap } from "@/types/socket-events";

type StoredHandler = SocketEventHandler<keyof SocketEventMap>;

class SocketEmitter {
  private handlers = new Map<keyof SocketEventMap, StoredHandler>();

  on<K extends keyof SocketEventMap>(event: K, handler: SocketEventHandler<K>): () => void {
    this.handlers.set(event, handler as StoredHandler);

    return () => this.off(event, handler);
  }

  off<K extends keyof SocketEventMap>(event: K, handler: SocketEventHandler<K>): void {
    if (this.handlers.get(event) === (handler as StoredHandler)) {
      this.handlers.delete(event);
    }
  }

  emit<K extends keyof SocketEventMap>(event: K, payload: SocketEventMap[K]): void {
    this.handlers.get(event)?.(payload);
  }
}

export const socketEmitter = new SocketEmitter();
